import { Box } from '@material-ui/core';
import { formatDateTimeReadable, Loan } from '@nemuru-eng/js-api-client';

import { OverviewDetailRow } from '@/components/shared/components/OverviewDetailRow';
import { PurchaseCountryWithFlag } from '@/components/shared/components/PurchaseCountryWithFlag';
import { Text } from '@/components/shared/components/Text';

export const LoanHeaderDetails = ({ loan, showClientData }: { loan: Loan; showClientData: boolean }) => {
  return (
    <Box display={'flex'} flexDirection={'column'}>
      <OverviewDetailRow field={<Text tId={'LOAN_ID'} />} value={loan.id} copyButton />
      <OverviewDetailRow field={<Text tId={'CREATED_AT'} />} value={formatDateTimeReadable(loan.createdAt)} />
      {showClientData && (
        <OverviewDetailRow
          field={<Text tId={'CLIENT_CONTACT_EMAIL'} />}
          value={loan.onboardingDetails[0].invitation.email}
        />
      )}
      <OverviewDetailRow
        field={<Text tId={'PURCHASE_COUNTRY_TITLE'} />}
        value={<PurchaseCountryWithFlag purchaseCountry={loan.purchaseCountry} />}
      />
    </Box>
  );
};
